import { useContext } from 'react';
import Context from './context';

export default function useExploreContext() {
  const context = useContext(Context);
  return context;
}
